import React from 'react'

interface Datas {
  datas: {
    flamelinkAboutContent: {
      alt: string
      width: number
      height: number
      image: {
        url: string
      }[]
    }
  }
}

const s = {
  grid: `w-full h-full grid-3 gap-8 mdx:grid-cols-1 mdx:gap-12`,
  image: `w-full h-full object-cover mdm:h-h70 smm:h-h40 xsx:h-h32`,
}

const Image = ({ datas }: Datas) => {
  const { alt, width, height, image } = datas.flamelinkAboutContent

  return (
    <div className={s.grid}>
      {image.map((img, id) => (
        <img
          key={id}
          className={s.image}
          src={img.url}
          alt={alt}
          width={width}
          height={height}
        />
      ))}
    </div>
  )
}

export default Image
